import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "yes",
  "use": "yes-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"yes\">\n<style type=\"text/css\">\n\t#yes .st0{fill:none;}\n</style>\n<title>yes</title>\n<rect id=\"yes__矩形_\" class=\"st0\" width=\"20\" height=\"20\" />\n<path id=\"yes__矩形_2\" d=\"M6,14.8L17.7,3.2c0.5-0.5,1.4-0.5,1.9,0l0,0c0.5,0.5,0.5,1.4,0,1.9L8,16.8c-0.5,0.5-1.4,0.5-1.9,0l0,0\n\tC5.5,16.2,5.5,15.4,6,14.8z\" />\n<path id=\"yes__矩形_2-2\" d=\"M0.4,9.3L0.4,9.3c0.5-0.5,1.4-0.5,1.9,0l5.6,5.6c0.5,0.5,0.5,1.4,0,1.9l0,0c-0.5,0.5-1.4,0.5-1.9,0\n\tl-5.6-5.6C-0.1,10.7-0.1,9.8,0.4,9.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/yes.svg
// module id = kWg0
// module chunks = 264